<!-- Content Wrapper Start -->
<div class="fm-content-wrapper">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="row align-items-center">
          <div class="col-sm">
            <!-- Page Title -->
            <div class="fm-page-title">
              <h2 class="fm-head-24 fm-title mb-2">
                {{ isEditMode() ? 'Edit Storybook' : 'Create Storybook' }}
              </h2>
              <p class="mb-0">
                {{
                  isEditMode()
                    ? 'Update the title, description, cover, memory date, or stories included.'
                    : 'Create beautiful books from your life stories to share and treasure'
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Create Story Book Section Start -->
    <div class="row">
      <div class="col-lg-8 col-xxl-8">
        <div class="row">
          <div class="col-xl-12">
            <div class="fm-white-column fm-match-height">
              <div class="accordion fm-accordion fm-accordion-st2">
                <div class="accordion-item fm-accordion-item mt-0">
                  <span class="accordion-header fm-accordion-header">
                    <button class="accordion-button fm-accordion-button">Storybook Details</button>
                  </span>
                  <div id="fmStoryDetails">
                    <div class="accordion-body fm-accordion-body pt-3">
                      <div class="row g-4 mx-0">
                        <div class="col-md-6">
                          <div class="row">
                            <div class="col-12">
                              <div class="form-group">
                                <label class="form-label fm-label"
                                  >Storybook Title <span class="fm-required">*</span></label
                                >
                                <input
                                  type="text"
                                  class="form-control fm-form-control"
                                  [class.is-invalid]="titleError()"
                                  placeholder="Enter storybook title"
                                  [ngModel]="title()"
                                  (ngModelChange)="title.set($event); titleError.set('')"
                                  name="storybookTitle"
                                  maxlength="150"
                                />
                                @if (titleError()) {
                                  <p class="fm-error-msg">{{ titleError() }}</p>
                                }
                              </div>
                            </div>
                            <div class="col-12 mt-3">
                              <div class="form-group">
                                <label class="form-label fm-label">Description (optional)</label>
                                <textarea
                                  class="form-control fm-form-control"
                                  placeholder="Enter storybook description"
                                  [ngModel]="description()"
                                  (ngModelChange)="description.set($event)"
                                  name="storybookDescription"
                                  maxlength="1000"
                                ></textarea>
                              </div>
                            </div>
                            <div class="col-12 mt-3">
                              <div class="form-group">
                                <label class="form-label fm-label"
                                  >Date of the Memory (optional)</label
                                >
                                <div class="fm-datepicker-wrapper">
                                  <div
                                    class="fm-datepicker-trigger form-control fm-form-control"
                                    style="
                                      display: flex;
                                      align-items: center;
                                      gap: 8px;
                                      cursor: pointer;
                                    "
                                    (click)="openDatePicker($event)"
                                  >
                                    <img
                                      class="fm-svg"
                                      src="images/icons/fm-calendar.svg"
                                      alt="Date Icon"
                                      style="width: 16px; height: 16px; flex-shrink: 0"
                                    />
                                    <span [class.fm-dp-placeholder]="!memoryDateDisplay()">
                                      {{ memoryDateDisplay() || 'Select date' }}
                                    </span>
                                  </div>
                                  @if (showDatePicker()) {
                                    <div class="fm-dp-backdrop" (click)="closeDatePicker()"></div>
                                    <div
                                      class="fm-dp-dropdown"
                                      [class.fm-dp-dropup]="pickerDropUp()"
                                    >
                                      <div class="fm-dp-header">
                                        <button
                                          type="button"
                                          class="fm-dp-nav"
                                          (click)="pickerPrevMonth()"
                                        >
                                          &#8249;
                                        </button>
                                        <span class="fm-dp-month-label">{{
                                          pickerMonthLabel()
                                        }}</span>
                                        <button
                                          type="button"
                                          class="fm-dp-nav"
                                          (click)="pickerNextMonth()"
                                        >
                                          &#8250;
                                        </button>
                                      </div>
                                      <div class="fm-dp-weekdays">
                                        <span>Su</span><span>Mo</span><span>Tu</span><span>We</span
                                        ><span>Th</span><span>Fr</span><span>Sa</span>
                                      </div>
                                      <div class="fm-dp-grid">
                                        @for (cell of pickerCalendarDays(); track $index) {
                                          <button
                                            type="button"
                                            class="fm-dp-day"
                                            [class.fm-dp-today]="cell.isToday"
                                            [class.fm-dp-selected]="cell.isSelected"
                                            [class.fm-dp-empty]="!cell.isCurrentMonth"
                                            [class.fm-dp-disabled]="cell.isDisabled"
                                            [disabled]="cell.isDisabled || !cell.isCurrentMonth"
                                            (click)="selectPickerDate(cell.date)"
                                          >
                                            {{ cell.day !== null ? cell.day : '' }}
                                          </button>
                                        }
                                      </div>
                                    </div>
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group fm-file-upload-group">
                            <label class="form-label fm-label">Cover Page Image (Optional)</label>
                            <div class="fm-thumbnail-upload-inline" id="fmAudioThumbnailUpload">
                              @if (!coverImagePreviewUrl()) {
                                <label
                                  for="fmAudioThumbnailInput"
                                  class="fm-thumbnail-upload-btn mb-0"
                                >
                                  <img
                                    src="images/icons/fm-upload-icon.svg"
                                    class="fm-svg"
                                    alt="Upload Thumbnail"
                                  />
                                  <span class="fm-upload-helper-text"
                                    >Drop your photo here, or
                                    <span class="fm-browse-text">Browse</span></span
                                  >
                                </label>
                              }
                              <input
                                type="file"
                                id="fmAudioThumbnailInput"
                                class="fm-thumbnail-file-input"
                                accept="image/jpeg,image/png,image/webp"
                                (change)="onCoverImageSelected($event)"
                              />
                              @if (coverImagePreviewUrl()) {
                                <div class="fm-thumbnail-preview" id="fmAudioThumbnailPreview">
                                  <img
                                    [src]="coverImagePreviewUrl()"
                                    class="fm-thumbnail-preview-image"
                                    alt="Cover Preview"
                                  />
                                  <div class="fm-thumbnail-preview-info">
                                    <span class="fm-thumbnail-preview-name">{{
                                      isUploadingCover() ? 'Uploading…' : coverImageFileName()
                                    }}</span>
                                  </div>
                                  <button
                                    type="button"
                                    class="fm-x-btn fm-thumbnail-remove-btn"
                                    aria-label="Remove thumbnail"
                                    [disabled]="isUploadingCover()"
                                    (click)="removeCoverImage()"
                                  >
                                    <img src="images/icons/fm-x.svg" alt="Remove" />
                                  </button>
                                </div>
                              }
                              @if (coverImageError()) {
                                <p class="fm-error-msg">{{ coverImageError() }}</p>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 mt-2 mt-xl-3">
            <div class="fm-white-column">
              <div class="row gy-3 gx-3 gx-xl-4 align-items-center">
                <div class="col-12 col-sm">
                  <h2 class="fm-head-24 fm-title fm-title-dark mb-2">Select Stories</h2>
                  <p class="mb-0">
                    {{ selectedStoriesCount() }} of {{ totalRecords() }} stories selected
                  </p>
                
                  @if (storiesError()) {
                    <p class="fm-error-msg">{{ storiesError() }}</p>
                  }
                </div>
                <div class="col-sm-auto">
                  <div class="row gy-3 gx-3 gx-xl-4 align-items-center">
                    <!-- <div class="col">
                                          <select class="form-select fm-form-select" [ngModel]="activeViewType()" (ngModelChange)="onViewTypeChange($event)">
                                             @for (opt of viewTypeOptions; track opt.value) {
                                                <option [value]="opt.value">{{ opt.label }}</option>
                                             }
                                          </select>
                                       </div> -->
                    <div class="col-auto">
                      <button
                        type="button"
                        class="form-select fm-form-select"
                        [class.fm-filters-open]="isFilterPanelOpen()"
                        (click)="toggleFilterPanel()"
                      >
                        Advanced Filters
                      </button>
                    </div>
                    <div class="col-auto">
                      <div class="fm-filter-btn-grp">
                        <button
                          type="button"
                          class="fm-filter-cl-btn fm-filter-grid-btn"
                          [class.fm-fb-active]="viewMode() === 'grid'"
                          (click)="setViewMode('grid')"
                        >
                          <img src="images/icons/fm-column.svg" class="fm-svg" alt="Grid View" />
                        </button>
                        <button
                          type="button"
                          class="fm-filter-cl-btn fm-filter-list-btn"
                          [class.fm-fb-active]="viewMode() === 'list'"
                          (click)="setViewMode('list')"
                        >
                          <img src="images/icons/fm-list.svg" class="fm-svg" alt="List View" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-12">
                  <div class="fm-searchbar pe-xl-2">
                    <form (ngSubmit)="onSearch()">
                      <div class="form-group">
                        <input
                          class="form-control"
                          type="text"
                          placeholder="Search stories by title, people"
                          [(ngModel)]="customSearch"
                          name="storySearch"
                        />
                      </div>
                      @if (submittedSearch()) {
                        <button type="button" class="fm-search-btn" (click)="clearSearch()">
                          &#x2715;
                        </button>
                      } @else {
                        <button class="fm-search-btn" type="submit">
                          <img
                            src="images/icons/fm-search-icon.svg"
                            class="fm-svg"
                            alt="Search Icon"
                          />
                        </button>
                      }
                    </form>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="fm-filter-tags fm-filter-tags-scroll mt-4" tabindex="0">
                    <button
                      type="button"
                      class="fm-filter-tag fm-filter-btn"
                      [class.fm-ft-active]="activeCategoryId() === null"
                      (click)="setCategory(null)"
                    >
                      All Stories
                    </button>
                    @for (cat of categories(); track cat.categoryId) {
                      <button
                        type="button"
                        class="fm-filter-tag fm-filter-btn"
                        [class.fm-ft-active]="activeCategoryId() === cat.categoryId"
                        (click)="setCategory(cat.categoryId)"
                      >
                        {{ cat.categoryName }}
                        @if (activeCategoryId() === cat.categoryId) {
                          <span
                            class="fm-tag-close"
                            (click)="$event.stopPropagation(); setCategory(null)"
                            >&#x2715;</span
                          >
                        }
                      </button>
                    }
                  </div>
                </div>
              </div>

              @if (isFilterPanelOpen()) {
                <div class="fm-filter-panel mt-3">
                  <hr class="fm-filter-divider mt-0" />
                  <div class="fm-filter-group">
                    <p class="fm-black-cl fm-ft-title mt-xl-2">
                      <img src="images/icons/fm-fg-icon.svg" alt="Family Icon" /> Filter by Family
                    </p>
                    <div class="fm-filter-tags fm-filter-tags-wrap">
                      <button
                        type="button"
                        class="fm-filter-tag fm-filter-btn"
                        [class.fm-ft-active]="activeFamilySpaceId() === null"
                        (click)="onFamilySpaceChange('')"
                      >
                        All Family
                      </button>
                      @for (family of familySpaces(); track family.familySpaceId) {
                        <button
                          type="button"
                          class="fm-filter-tag fm-filter-btn"
                          [class.fm-ft-active]="activeFamilySpaceId() === family.familySpaceId"
                          (click)="onFamilySpaceChange(family.familySpaceId)"
                        >
                          {{ family.familyName }}
                          @if (activeFamilySpaceId() === family.familySpaceId) {
                            <span
                              class="fm-tag-close"
                              (click)="$event.stopPropagation(); onFamilySpaceChange('')"
                              >&#x2715;</span
                            >
                          }
                        </button>
                      }
                    </div>
                  </div>
                  <hr class="fm-filter-divider" />
                  <div class="fm-filter-group">
                    <p class="fm-black-cl fm-ft-title">
                      <img src="images/icons/fm-fp-icon.svg" alt="Tagged Person Icon" /> Filter by
                      Tagged Person
                    </p>
                    <div class="fm-filter-tags fm-filter-tags-wrap">
                      <button
                        type="button"
                        class="fm-filter-tag fm-filter-btn"
                        [class.fm-ft-active]="activeTaggedPersonIds().length === 0"
                        (click)="activeTaggedPersonIds.set([]); pageNumber.set(1); loadStories()"
                      >
                        All People
                      </button>
                      @for (member of filteredFamilyMembers(); track member.familyMemberId) {
                        <button
                          type="button"
                          class="fm-filter-tag fm-filter-btn"
                          [class.fm-ft-active]="
                            activeTaggedPersonIds().includes(member.familyMemberId)
                          "
                          (click)="toggleTaggedPerson(member.familyMemberId)"
                        >
                          {{ member.fullName }}
                          @if (activeTaggedPersonIds().includes(member.familyMemberId)) {
                            <span
                              class="fm-tag-close"
                              (click)="
                                $event.stopPropagation(); toggleTaggedPerson(member.familyMemberId)
                              "
                              >&#x2715;</span
                            >
                          }
                        </button>
                      }
                    </div>
                  </div>
                  <hr class="fm-filter-divider" />
                  <div class="fm-filter-group">
                    <p class="fm-black-cl fm-ft-title">
                      <img src="images/icons/fm-fp-icon.svg" alt="Creator Icon" /> Filter by Creator
                    </p>
                    <div class="fm-filter-tags fm-filter-tags-wrap">
                      <button
                        type="button"
                        class="fm-filter-tag fm-filter-btn"
                        [class.fm-ft-active]="activeCreatorIds().length === 0"
                        (click)="activeCreatorIds.set([]); pageNumber.set(1); loadStories()"
                      >
                        All Creator
                      </button>
                      @for (creator of filteredCreators(); track creator.userId) {
                        <button
                          type="button"
                          class="fm-filter-tag fm-filter-btn"
                          [class.fm-ft-active]="activeCreatorIds().includes(creator.userId)"
                          (click)="toggleCreator(creator.userId)"
                        >
                          {{ creator.fullName }}
                          @if (activeCreatorIds().includes(creator.userId)) {
                            <span
                              class="fm-tag-close"
                              (click)="$event.stopPropagation(); toggleCreator(creator.userId)"
                              >&#x2715;</span
                            >
                          }
                        </button>
                      }
                    </div>
                  </div>

                  @if (hasActiveFilters) {
                    <hr class="fm-filter-divider" />
                    <div class="fm-filter-group">
                      <div class="fm-filter-title">
                        <p class="fm-black-cl fm-ft-title mb-0">
                          <img src="images/icons/fm-af-icon.svg" alt="Applied Filters Icon" />
                          Applied Filters
                        </p>
                        <p
                          class="fm-black-cl fm-ft-title mb-0"
                          style="cursor: pointer"
                          (click)="clearAllFilters()"
                        >
                          Clear All Filters <img src="images/icons/fm-bl-x.svg" alt="Clear Icon" />
                        </p>
                      </div>
                      <div class="fm-filter-tags fm-filter-tags-wrap mt-3">
                        @if (activeCategoryId() !== null) {
                          <button
                            type="button"
                            class="fm-filter-tag fm-filter-btn fm-ft-active"
                            (click)="setCategory(null)"
                          >
                            {{ getActiveCategoryName() }}
                            <span class="fm-tag-close">&#x2715;</span>
                          </button>
                        }
                        @if (activeViewType() !== null) {
                          <button
                            type="button"
                            class="fm-filter-tag fm-filter-btn fm-ft-active"
                            (click)="onViewTypeChange('')"
                          >
                            {{ getViewTypeName() }}
                            <span class="fm-tag-close">&#x2715;</span>
                          </button>
                        }
                        @if (activeFamilySpaceId() !== null) {
                          <button
                            type="button"
                            class="fm-filter-tag fm-filter-btn fm-ft-active"
                            (click)="onFamilySpaceChange('')"
                          >
                            {{ getActiveFamilyName() }}
                            <span class="fm-tag-close">&#x2715;</span>
                          </button>
                        }
                        @for (id of activeTaggedPersonIds(); track id) {
                          <button
                            type="button"
                            class="fm-filter-tag fm-filter-btn fm-ft-active"
                            (click)="toggleTaggedPerson(id)"
                          >
                            {{ familyMembers().find(m => m.familyMemberId === id)?.fullName }}
                            <span class="fm-tag-close">&#x2715;</span>
                          </button>
                        }
                        @for (id of activeCreatorIds(); track id) {
                          @let creatorName = creators().find(c => c.userId === id)?.fullName;
                          @if (creatorName) {
                            <button
                              type="button"
                              class="fm-filter-tag fm-filter-btn fm-ft-active"
                              (click)="toggleCreator(id)"
                            >
                              {{ creatorName }}
                              <span class="fm-tag-close">&#x2715;</span>
                            </button>
                          }
                        }
                      </div>
                    </div>
                  }
                </div>
              }

              @if (!isInitializing()) {
                @if (hasError()) {
                  <div class="fm-stories-empty-state text-center mt-4">
                    <h4 class="fm-head-24 fm-head-sty2">Something went wrong</h4>
                    <p class="mb-3">
                      We couldn't load your stories. Please check your connection and try again.
                    </p>
                  </div>
                } @else if (stories().length === 0) {
                  <div class="fm-stories-empty-state text-center mt-4">
                    <h4 class="fm-head-24 fm-head-sty2">No stories found</h4>
                    <p class="mb-0">
                      Try a different search term or filter to see available stories.
                    </p>
                  </div>
                } @else {
                  <div
                    class="row mt-2 g-3 fm-stories-grid align-items-stretch"
                    [class.fm-list-view]="viewMode() === 'list'"
                  >
                    @for (story of stories(); track story.storyId) {
                      <div
                        [class]="
                          viewMode() === 'grid'
                            ? 'col-12 col-sm-6 mt-4 fm-story-filter-item'
                            : 'col-12 mt-3 fm-story-filter-item'
                        "
                      >
                        <div
                          class="fm-stories-blog fm-match-height fm-story-select-card h-100"
                          [class.active]="story.isSelected"
                          (click)="toggleStorySelection(story)"
                          tabindex="0"
                          role="button"
                        >
                          <div class="fm-stories-cover">
                            <img
                              class="fm-image"
                              [src]="
                                story.thumbnailUrl ||
                                story.vimeoThumbnailUrl ||
                                'images/stories/stories-post-1.png'
                              "
                              alt="Review Cover Image"
                              onerror="this.src = 'images/stories/stories-post-1.png'"
                            />
                            <span class="fm-tag">{{ formatDuration(story.duration) }}</span>
                            <!--<button class="fm-stories-pp"><img src="images/icons/fm-play.svg" alt="Play Icon" class="fm-svg" /></button>-->
                          </div>
                          <div class="fm-stories-content">
                            <span class="fm-check-icon">
                              <img src="images/icons/fm-check.svg" class="fm-svg" alt="Selected" />
                            </span>
                            <div class="fm-st-promt-tag">
                              <span class="fm-st-ti">{{ story.categoryName || '—' }}</span>
                              <span class="fm-st-ti fm-light-green">
                                @if (story.mediaTypeName === 'Video') {
                                  <img
                                    src="images/icons/fm-video-icon.svg"
                                    class="fm-svg"
                                    alt="Video"
                                  />
                                } @else if (story.mediaTypeName === 'Audio') {
                                  <img
                                    src="images/icons/fm-micro-icon.svg"
                                    class="fm-svg"
                                    alt="Audio"
                                  />
                                } @else {
                                  <img
                                    src="images/icons/fm-camera.svg"
                                    class="fm-svg"
                                    alt="Media"
                                  />
                                }
                                {{ story.mediaTypeName }}
                              </span>
                            </div>
                            <h4 class="fm-head-20 fm-head-sty2">
                              <a>{{ story.title }}</a>
                            </h4>
                          </div>
                        </div>
                      </div>
                    }
                  </div>

                  @if (isLoadingMore()) {
                    <div class="fm-loading-more text-center mt-3">
                      <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Loading more...</span>
                      </div>
                    </div>
                  }
                  <div id="storiesScrollSentinel" style="height: 1px"></div>
                }
              }

              <div class="row">
                <div class="col-12 mt-4">
                  <div class="fm-ai-chapter-box">
                    <h4 class="fm-head-20 fm-title fm-title-dark mb-1">AI Chapter Organization</h4>
                    <p class="mb-3">
                      Our AI will automatically organize your stories into meaningful chapters and
                      add beautiful formatting
                    </p>
                    <ul class="fm-ai-chapter-list">
                      <li>
                        <img
                          src="images/icons/fm-check-green.svg"
                          class="fm-svg"
                          alt="Check Icon"
                        />
                        Chapter 1: Early Years (3 stories)
                      </li>
                      <li>
                        <img
                          src="images/icons/fm-check-green.svg"
                          class="fm-svg"
                          alt="Check Icon"
                        />
                        Chapter 2: Love & Family (1 story)
                      </li>
                      <li>
                        <img
                          src="images/icons/fm-check-green.svg"
                          class="fm-svg"
                          alt="Check Icon"
                        />
                        Chapter 3: Life's Work (1 story)
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-xxl-4">
        <div class="fm-sidebar-clumn mt-4 mt-lg-0">
          @if (!isCreated() || isEditMode()) {
            <div class="fm-border-column fm-book-preview-sidebar mb-3">
              <h3 class="fm-head-20 fm-sidebar-title mb-2">
                {{ isEditMode() ? 'Edit Details' : 'Ready to Create' }}
              </h3>
              <p class="mb-3">
                {{
                  isEditMode()
                    ? 'Update the details or story selection, then save your changes.'
                    : "Once you're happy with the details and stories you've picked, generate your storybook."
                }}
              </p>
              <button
                type="button"
                class="fm-common-btn fm-sm-btn w-100"
                [disabled]="isSubmitDisabled()"
                (click)="isEditMode() ? updateStorybook() : createStorybook()"
              >
                {{
                  isSubmitting()
                    ? (isEditMode() ? 'Saving…' : 'Creating…')
                    : (isEditMode() ? 'Save Changes' : 'Create Storybook')
                }}
              </button>
            </div>
          }
          <div class="fm-border-column fm-book-preview-sidebar">
            <h3 class="fm-head-20 fm-sidebar-title mb-0">Book Preview</h3>
            <div class="fm-book-cover-wrap">
              <img
                [src]="storybookDetail()?.coverImageUrl || 'images/storybooks/bookcover.png'"
                class="fm-book-cover-image"
                alt="Book Cover"
              />
            </div>
            @if (storybookDetail(); as detail) {
              <h4 class="fm-head-20 mt-3 mb-0">{{ detail.title }}</h4>
              <p class="mb-0">By {{ detail.authorName }}</p>
              <div class="fm-book-stats-box mt-3">
                <div class="fm-book-stat-item">
                  <h4 class="fm-head-20">{{ detail.totalStories }}</h4>
                  <p class="mb-0">Total Stories</p>
                </div>
                <div class="fm-book-stat-item">
                  <h4 class="fm-head-20">{{ detail.totalDuration || '0:00' }}</h4>
                  <p class="mb-0">Total Duration</p>
                </div>
                <div class="fm-book-stat-item">
                  <h4 class="fm-head-20">{{ detail.estimatedPages }}</h4>
                  <p class="mb-0">Est. Pages</p>
                </div>
              </div>
              <div class="fm-book-includes mt-4">
                <p>Your Storybook Includes:</p>
                @if (detail.includesPhotos) {
                  <div class="fm-book-include-item">
                    <div class="fm-book-include-icon">
                      <img src="images/icons/fm-photo.svg" class="fm-svg" alt="Photos Icon" />
                    </div>
                    <div>
                      <p class="fm-include-title mb-0">Photos & Images</p>
                      <p class="fm-include-text mb-0">Beautiful memories in every page</p>
                    </div>
                  </div>
                }
                @if (detail.includesAIText) {
                  <div class="fm-book-include-item mt-4">
                    <div class="fm-book-include-icon">
                      <img src="images/icons/fm-ai.svg" class="fm-svg" alt="AI Icon" />
                    </div>
                    <div>
                      <p class="fm-include-title mb-0">AI-Formatted Text</p>
                      <p class="fm-include-text mb-0">Structured stories, beautifully formatted</p>
                    </div>
                  </div>
                }
                @if (detail.includesQRCodes) {
                  <div class="fm-book-include-item mt-4">
                    <div class="fm-book-include-icon">
                      <img src="images/icons/fm-qr.svg" class="fm-svg" alt="QR Icon" />
                    </div>
                    <div>
                      <p class="fm-include-title mb-0">QR Codes to Videos</p>
                      <p class="fm-include-text mb-0">Scan to instantly watch your stories anytime</p>
                    </div>
                  </div>
                }
              </div>
            } @else {
              <div class="fm-book-preview-placeholder mt-3" [class.fm-loading]="isLoadingDetail()">
                <div class="fm-book-stats-box">
                  <div class="fm-book-stat-item">
                    <h4 class="fm-head-20">—</h4>
                    <p class="mb-0">Total Stories</p>
                  </div>
                  <div class="fm-book-stat-item">
                    <h4 class="fm-head-20">—</h4>
                    <p class="mb-0">Total Duration</p>
                  </div>
                  <div class="fm-book-stat-item">
                    <h4 class="fm-head-20">—</h4>
                    <p class="mb-0">Est. Pages</p>
                  </div>
                </div>
                <p class="fm-print-note mt-3 mb-0">
                  {{
                    isLoadingDetail()
                      ? 'Loading your storybook…'
                      : 'Book details will appear here once your storybook is created.'
                  }}
                </p>
              </div>
            }
            <div class="row g-3 mt-2">
              <div class="col-12">
                <button
                  type="button"
                  class="fm-common-btn fm-secondary-btn fm-sm-btn fm-white-btn-txt w-100"
                  [disabled]="!isCreated() || isLoadingPreview()"
                  [appTooltip]="isCreated() ? '' : 'Available once the storybook is created'"
                  (click)="previewStorybook()"
                >
                  {{ isLoadingPreview() ? 'Loading…' : 'Preview Book' }}
                  <img src="images/icons/fm-eye-white.svg" class="fm-svg" alt="Preview Icon" />
                </button>
              </div>
              <div class="col-12">
                <button
                  type="button"
                  class="fm-common-btn fm-secondary-btn fm-sm-btn fm-white-btn-txt w-100"
                  [disabled]="!isCreated() || exportingType() !== null"
                  [appTooltip]="isCreated() ? '' : 'Available once the storybook is created'"
                  (click)="exportStorybook(StorybookExportType.Pdf)"
                >
                  {{ exportingType() === StorybookExportType.Pdf ? 'Downloading…' : 'Download PDF' }}
                  <img
                    src="images/icons/fm-download-white.svg"
                    class="fm-svg"
                    alt="Download Icon"
                  />
                </button>
              </div>
            </div>
            <div class="row g-3 mt-2">
              <div class="col-12">
                <button
                  type="button"
                  class="fm-common-btn fm-border-btn fm-sm-btn w-100"
                  [disabled]="!isCreated() || exportingType() !== null"
                  [appTooltip]="isCreated() ? '' : 'Available once the storybook is created'"
                  (click)="exportStorybook(StorybookExportType.Doc)"
                >
                  {{ exportingType() === StorybookExportType.Doc ? 'Exporting…' : 'Export DOCX' }}
                  <img
                    src="images/icons/fm-doc.svg"
                    class="d-lg-none d-xxl-inline"
                    alt="Export Icon"
                  />
                </button>
              </div>
            </div>
            <div class="row g-3 mt-2">
              <div class="col-12">
                <button
                  type="button"
                  class="fm-common-btn fm-border-btn fm-sm-btn w-100"
                  [disabled]="!isCreated() || isGeneratingQrCode()"
                  [appTooltip]="isCreated() ? '' : 'Available once the storybook is created'"
                  (click)="generateQrCode()"
                >
                  {{ isGeneratingQrCode() ? 'Generating…' : 'Generate Shareable QR Code' }}
                  <img src="images/icons/fm-qr.svg" class="fm-svg" alt="QR Icon" />
                </button>
              </div>
            </div>
            @if (qrCodeUrl()) {
              <div class="fm-book-qr-result mt-3 text-center">
                <img [src]="qrCodeUrl()" alt="Storybook QR Code" class="fm-book-qr-image" />
                <p class="fm-print-note mt-2 mb-0" style="word-break: break-all;">
                  {{ shareableLink() }}
                </p>
              </div>
            }
          </div>
        </div>
      </div>
      <!-- Create Story Book Section End -->
    </div>
  </div>
  <!-- Content Wrapper End -->
</div>

@if (previewData(); as preview) {
  <app-storybook-preview-modal [data]="preview" (closed)="closePreview()" />
}
